import { Button, Typography } from "@mui/material";
import { useState } from "react";

const CaltexUpload = (props) => {
    const { field, onChange } = props;
    const [file, setFile] = useState(props.value);

    const handleUpload = (e) => {
        setFile(e.target.files[0]);
        onChange(field, e, e.target.files[0]);
    };

    return (
        <>
            <Button variant="contained" component="label" sx={{ maxWidth: "180px", backgroundColor: "#004B61" }}>
                Upload
                <input hidden accept="image/*" type="file" onChange={handleUpload} />
            </Button>
            <Typography>{file ? file.name : ""}</Typography>
        </>
    );
};

export default CaltexUpload;
